import Vue from 'vue';
import VueRouter from 'vue-router';
import routeModules from './routes';

Vue.use(VueRouter);
const publicPath = process.env.VUE_APP_PUBLIC_PATH;
const routes = [
  {
    path: '/',
    redirect: '/devices',
  },
  ...routeModules,
  {
    path: '*',
    component: () => import('@/views/errors/404.vue'),
  },
];

const router = new VueRouter({
  base: publicPath,
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({x: 0, y: 0});
      }, 500);
    });
  },
});
export default router;
